import { combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'


import userReducer from '../containers/user-container/reducer/userSlice'
import authReducer from '../containers/auth-container/reducer/authSlice'
import courseFormReducer from '../containers/course-container/reducer/courseFormSlice'
import universityFormReducer from '../containers/university-container/reducer/universityFormSlice'
import specializationFormReducer from '../containers/specialization-container/reducer/specializationFormSlice'
import scheduleCallReducer from "../containers/schedule-call-container/reducer/scheduleCallSlice"
import paginationReducer from "../containers/pagination-container/reducer/paginationSlice"
import filterReducer from "../containers/filter-container/reducer/filterSlice"


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'auth','pagination','filter']
}

const rootReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  courseForm: courseFormReducer,
  universityForm: universityFormReducer,
  specializationForm: specializationFormReducer,
  schedulecall:scheduleCallReducer,
  pagination:paginationReducer,
  filter:filterReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
        ],
      },
    })
})

export const persistor = persistStore(store)
